import service from '@/utils/request'
// 查询币种
export function basicMakerList(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/productManufacturerList',
        data: param
    })
}
// 新增
export function basicMakeradd(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/add',
        data: param
    })
}
// 修改
export function basicMakeredit(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/edit',
        data: param
    })
}
// 删除
export function basicMakerdel(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/del',
        data: param
    })
}
// 批量删除
export function basicMakerbatchDel(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/batchDel',
        data: param
    })
}
// 获取所有的制造商
export function getProductAllList(param) {
    return service.request({
        method: 'POST',
        url: '/app/productManufacturer/list',
        data: param
    })
}
